import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/project/$projectId/contracts/$')({
  beforeLoad: ({ location }) => {
    throw redirect({
      href: location.href.replace('/contracts/', '/workspaces/'),
      replace: true,
    });
  },
});
